import { Callback } from '@/domain/services/Rt/DataSource';
import { flagsSubmittable, FlagsSubmittableData } from '@/domain/services/Collaboration/FlagsSubmittable';

type EntryFormFlagsSubmittable = {
	init: (data: FlagsSubmittableData, forceSet?: boolean) => void;
	subscribe: (callback: Callback<unknown>) => void;
};
const entryFormFlagsSubmittable = (): EntryFormFlagsSubmittable => {
	const service = flagsSubmittable().service;
	const init = (data: FlagsSubmittableData, forceSet = false) => service.set(data, forceSet);

	return {
		init,
		subscribe: service.subscribe,
	};
};

export { entryFormFlagsSubmittable };
